import { create } from "zustand";
import { persist, devtools } from "zustand/middleware";

import { UrlApi } from "../api";
import { safeStorage } from "./ssrStorage";

interface UrlState {
	navigationLinks: Array<{ name: string; url: string }>;
	navigationLinkUpdate: number | false;
	setNavigationLinks: (links: Array<{ name: string; url: string }>) => void;
	GetUrl: (params: Record<string, any>) => Promise<{ url: string }>;
	GetNavigationLinks: () => Promise<Array<{ name: string; url: string }>>;
}

const useUrlStorage = create<UrlState>()(
	persist(
		devtools((set, get) => ({
			navigationLinks: [],
			navigationLinkUpdate: false,
			setNavigationLinks: (links) => {
				set({ navigationLinks: links ?? [], navigationLinkUpdate: Date.now() });
			},
			async GetUrl(params) {
				const urlInfo = await UrlApi.GetUrl(params);
				return urlInfo;
			},
			async GetNavigationLinks() {
				if (get().navigationLinkUpdate && get().navigationLinkUpdate > Date.now() - 300000) {
					return get().navigationLinks;
				}

				const res = await UrlApi.GetNavigationLinks();
				set({ navigationLinks: res, navigationLinkUpdate: Date.now() });
				return res;
			},
		})),
		{
			name: "url-storage",
			storage: safeStorage,
			merge: (persistedState, currentState) => {
				const persistedLinks = persistedState?.navigationLinks;
				const hasPersistedLinks = Array.isArray(persistedLinks) && persistedLinks.length > 0;
				return {
					...currentState,
					...persistedState,
					navigationLinks: hasPersistedLinks ? persistedLinks : currentState.navigationLinks,
					navigationLinkUpdate: persistedState?.navigationLinkUpdate || currentState.navigationLinkUpdate,
				};
			},
		},
	),
);

export { useUrlStorage };
